<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="2.75" y="5.75" width="18.5" height="12.5" rx="1.25" stroke="#000" stroke-width="1.5"/>
  <path d="M3 6L12 13L21 6" stroke="#000" stroke-width="1.5"/>
</svg>
